import React, {useEffect,useState} from 'react';
import {createTheme, makeStyles, MuiThemeProvider} from '@material-ui/core/styles';
import {Box, Button, Divider,  Icon, Paper, TextField, Typography} from '@material-ui/core'
import SyncCloud from './syncCloud.png'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {red} from '@material-ui/core/colors';
import {ApiPostData} from "@project/shared/src/services/ApiPostData";
import {commonValidation} from "@project/shared/src/services/commonValidation";
import {BaseServer, BaseURL} from "@project/shared/src/services/postData";
import MaterialUiButtons from "@project/shared/src/components/button/materialUiButton";

const theme = createTheme({
  overrides: {
    MuiOutlinedInput: {
      root: {
        "&$focused $notchedOutline": {
          border: "1px solid #66afe9 !important",
          outline: 'none',
          boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6) !important"
        },
      },
    },
  },
  typography: {fontFamily: ['"Montserrat", sans-serif'+'!important'].join(','),},
});


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,

    textAlign: 'left',
  },
  saveBtn:{
    background:'#045e06',
    color:'white'
  },
  paper: {
    padding: theme.spacing(4),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },

  customTextField :props=>({
    "& >label":{
    },
    "& .MuiSelect-icon":{
      position:"inherit",
      cursor:"pointer"
    },
    "&>div>fieldset>legend":{
      background:'white'
    },
    "& .MuiIconButton-root:focus":{
      outline:"none"
    },
    "& >div>svg":{
      right:props.iconData!==undefined?
        props.iconData.length===2?62:props.iconData.length===1?41:props.iconData.length===3?84:""
        :"",
    },
  }),

  phoneInput:{
    marginTop: '8px',
    marginBottom: '4px',
    position:'relative',
    "&:hover": {
      "&>div>input": {
        border: '1px solid black',
      },
      "& .flag-dropdown": {
        border: '1px solid black',
      },
    },
    "& .form-control":{
      width:"100%",
      "&:focus":{
        border: "1px solid #66afe9 !important",
        outline: 'none',
        boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6) !important"
      },
      height: '40px'
    }

  },
  errorStyle:{
    color: 'red',
    float: 'left',
    padding: '0 5px',
    transform: 'translate(-5px, 6px) scale(0.75)',
    background: 'white',
    height: 'max-content',
    marginTop: '-19px',
  },
  phoneTextLabel:{
    zIndex: '10',
    position: 'relative',
    background: 'white',
    padding:  '0 5px',
    left: '40px',
    color: 'rgba(0, 0, 0, 0.54)',
  }
}));
const fields = {
  otp: {value: '', valid: false, errorLabel: 'Enter Valid OTP', error: ''},
  };
const Activation = (props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [activationField, setActivationField] = useState({...fields});
  const [email, setEmail] = useState();
  const [formValid, setFormValid] = useState(false);




  useEffect(() => {
    getEmail();

    return () => {
    }
  }, [props]);


  const handleClickOpen = () => {
    let data = {};
    data['licence'] = props.licence;
    data['otp'] = activationField['otp'].value;
    data['email'] = email;
    ApiPostData('api/websiteApi.php', 'checkOtpValid', data).then(result => {
      if(!result['status']){
      setOpen(true);
      }else if(result['status']){
       // window.location.href = BaseURL+"setPsw?user="+result['user']+"&active="+result['code']+"&lic="+props.licence;
        window.location.href = BaseServer+"setPsw/"+result['user']+"/"+result['code']+"/"+props.licence;
      }
    });

  };


  const handleClose = () => {
    setOpen(false);
  };

  const blurInField = (e, fieldname) => {
    let updateForm = {...activationField};

    let updateFormField = updateForm[fieldname];
    updateFormField.value = e.target.value;
    setActivationField(updateForm);

  }

  const changeInField = (e, fieldname,validationType) => {
    let updateForm = {...activationField};

    let updateFormField = updateForm[fieldname];
    updateFormField.value = e.target.value;
    updateFormField.valid = commonValidation(e.target.value, validationType);

    if (!updateForm[fieldname].valid) {
      updateFormField.error = updateFormField.errorLabel;
    } else {
      updateFormField.error = '';
    }
    let formValidVar = true;
    updateForm[fieldname] = updateFormField

    for (let key in activationField) {
      formValidVar = updateForm[key].valid && formValidVar;
    }
    setActivationField(updateForm);
    setFormValid(formValidVar)
  }


  const getEmail=()=>{
    let data = {};
    data['licence'] = props.licence;
    ApiPostData('api/websiteApi.php', 'getEmailOfLicence', data).then(result => {
      if(result.length>0){
        setEmail(result[0]['contact_person_email']);
      }
    });
  }

  return (
    <MuiThemeProvider theme={theme}>
      <Box className={classes.root} pt={2} px={3}>
        <img src={SyncCloud} alt='SyncCloud' style={{height: 130}}/>

        <Paper className={classes.paper}>
          <Typography variant="h5" color='textPrimary'>
           Licence Activation
          </Typography>

          <form className={classes.form} noValidate autoComplete="off">
            <Box py={2}>
              <label>Email :</label>{email}
            </Box>

            <Box py={2}>
            <TextField
              label='Enter the OTP'
              variant='outlined'
              size='small'
              required
              fullWidth
              className={classes.customTextField}
              value={activationField['otp'].value}
              onChange={(event) => changeInField(event, 'otp', {required: true, validationType: ''})}
              onBlur={(event) => blurInField(event, 'otp')}
            />
            {!activationField['otp'].valid ?
              <div className={classes.errorStyle}>
                  <Typography variant="caption" style={{color: 'red'}}>
                    {activationField['otp'].error}
                  </Typography>
              </div>
              :
              ""
            }
            </Box>



            <Box textAlign="right">
              <a href={`${BaseURL}`} style={{textDecoration:'none'}}>
                <MaterialUiButtons
                  iconName="close"
                  color="#f34225"
                  btnTitle="Cancel"
                />
              </a>
              <MaterialUiButtons
                iconName="save"
                btnClick={handleClickOpen}
                color="#1b5e20"
                btnTitle="Submit"
                btnDisable={!formValid}
              />
            </Box>


            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                <Box textAlign='center' mt={2}>
                  <Icon style={{fontSize: 50, color: red[500]}}>check_circle</Icon>
                </Box>


              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <Box textAlign='center'>
                    Invalid OTP
                  </Box>
                </DialogContentText>
              </DialogContent>
              <Divider/>
              <DialogActions>

                <Button variant="contained" onClick={handleClose} color="primary" autoFocus>
                  Ok
                </Button>
              </DialogActions>
            </Dialog>


          </form>

        </Paper>

      </Box>
    </MuiThemeProvider>
  );
};

export default Activation;
